document.addEventListener('DOMContentLoaded', function() {
   const searchIcon = document.querySelector('.search-icon');
   const fullscreenSearch = document.querySelector('.fullscreen-search');
   const closeBtn = document.querySelector('.fullscreen-search .close-btn');

   if (searchIcon && fullscreenSearch) {
      // Toggle fullscreen search when clicking search icon
      searchIcon.addEventListener('click', function(e) {
         e.preventDefault();
         fullscreenSearch.classList.add('active');
      });

      // Close fullscreen search when clicking close button
      if (closeBtn) {
         closeBtn.addEventListener('click', function() {
            fullscreenSearch.classList.remove('active');
         });
      }

      // Close fullscreen search when pressing Escape key
      document.addEventListener('keydown', function(e) {
         if (e.key === 'Escape' && fullscreenSearch.classList.contains('active')) {
            fullscreenSearch.classList.remove('active');
         }
      });
   }
});